const ExpandMapIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="21"
      viewBox="0 0 20 21"
      fill="none"
    >
      <path
        d="M17.5 8.625C17.1583 8.625 16.875 8.34167 16.875 8V3.625H12.5C12.1583 3.625 11.875 3.34167 11.875 3C11.875 2.65833 12.1583 2.375 12.5 2.375H17.5C17.8417 2.375 18.125 2.65833 18.125 3V8C18.125 8.34167 17.8417 8.625 17.5 8.625Z"
        fill="#2C3138"
      />
      <path
        d="M7.5 18.625H2.5C2.15833 18.625 1.875 18.3417 1.875 18V13C1.875 12.6583 2.15833 12.375 2.5 12.375C2.84167 12.375 3.125 12.6583 3.125 13V17.375H7.5C7.84167 17.375 8.125 17.6583 8.125 18C8.125 18.3417 7.84167 18.625 7.5 18.625Z"
        fill="#2C3138"
      />
      <path
        d="M11.2499 9.87292C11.0915 9.87292 10.9332 9.81458 10.8082 9.68958C10.5665 9.44792 10.5665 9.04792 10.8082 8.80625L17.0582 2.55625C17.2999 2.31458 17.6999 2.31458 17.9415 2.55625C18.1832 2.79792 18.1832 3.19792 17.9415 3.43958L11.6915 9.68958C11.5665 9.81458 11.4082 9.87292 11.2499 9.87292Z"
        fill="#2C3138"
      />
      <path
        d="M2.49987 18.6229C2.34154 18.6229 2.1832 18.5646 2.0582 18.4396C1.81654 18.1979 1.81654 17.7979 2.0582 17.5562L8.3082 11.3062C8.54987 11.0646 8.94987 11.0646 9.19154 11.3062C9.4332 11.5479 9.4332 11.9479 9.19154 12.1896L2.94154 18.4396C2.81654 18.5646 2.6582 18.6229 2.49987 18.6229Z"
        fill="#2C3138"
      />
    </svg>
  );
};

export default ExpandMapIcon;
